import { ICSSInJSStyle, useFluentContext } from "@fluentui/react-northstar";
import { CSSProperties } from "react";

type LinkStyles = {
  textStyles: ICSSInJSStyle;
  linkStyles: CSSProperties;
};

export const useLinkStyles = (): LinkStyles => {
  const { theme } = useFluentContext();
  return {
    textStyles: {
      textDecoration: "underline",
    },
    linkStyles: {
      color: theme.siteVariables.colorScheme.brand.foreground,
    },
  };
};
